<template>
  <w-icon-wrapper
    :height='23.216'
    :width='24'
    icon-name='work-collapse-icon'
    view-box='0 0 24 23.216'
  >
    <g
      id="_82_Auklappen_Icon"
      data-name="82 Auklappen_Icon"
      transform="translate(-670.23 -432.82)"
    >
      <path
        id="Pfad_55820"
        data-name="Pfad 55820"
        d="M688.77,449.18v2.39h-8.66a7.886,7.886,0,0,0,2.92-2.39Z"
        transform="translate(0.071 0.084)"
        fill="currentColor"
      />
      <path
        id="Pfad_55821"
        data-name="Pfad 55821"
        d="M688.77,444.38v2.39h-4.5a7.863,7.863,0,0,0,.37-2.39Z"
        transform="translate(0.08 0.059)"
        fill="currentColor"
      />
      <path
        id="Pfad_55822"
        data-name="Pfad 55822"
        d="M687.269,432.82h-9.275a2.321,2.321,0,0,0-2.314,2.321v1.326a7.83,7.83,0,0,1,.976-.06,8.515,8.515,0,0,1,1.348.11v-1.376h8.118v5.8h5.794l-.01,12.779H678v-1.376a8.511,8.511,0,0,1-1.348.111,7.83,7.83,0,0,1-.976-.06v1.326a2.306,2.306,0,0,0,2.3,2.321h13.923a2.317,2.317,0,0,0,2.324-2.321V439.782Z"
        transform="translate(0 0)"
        fill="currentColor"
      />
      <path
        id="Pfad_55822-2"
        data-name="Pfad 55822"
        d="M677.99,438.1a6.5,6.5,0,0,0-1.34-.141,6.193,6.193,0,0,0-.97.081,6.474,6.474,0,0,0,0,12.785,6.193,6.193,0,0,0,.97.081,6.5,6.5,0,0,0,1.34-.141,6.016,6.016,0,0,0,1.95-.786,5.085,5.085,0,0,0,.97-.706,6.438,6.438,0,0,0,2.17-4.84A6.464,6.464,0,0,0,677.99,438.1Zm-2.12,10.143-3.77-3.811,3.77-3.821.66.676-3.1,3.146,3.1,3.136Zm4.07-.676-.67.676-3.77-3.811,3.77-3.821.67.676-3.1,3.146Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconUnfold' };
</script>
